import { useEffect, useState } from 'react';
import { COMMENTS_TITLE } from '../shared/AppConstants';
import EntityListComp from './EntityListComp';
import { dmsmApi } from '../utils/api-clients/api-clients';

export default function CommentComp(props) {
  const [commentData, setCommentData] = useState([]);
  const { userInfoMap, isEdit, commonProps } = props;
  const {
    strategyNumber,
    incrementAPIInProgress,
    decrementAPIInProgress,
    setStatusErrorMsg,
    tokenAvailable
  } = commonProps;

  useEffect(() => {
    if (!tokenAvailable || !strategyNumber) return;

    async function fetchComments() {
      incrementAPIInProgress();
      try {
        const { data, error } = await dmsmApi.fetchClient.request(
          ...dmsmApi.operations.findAllCommentsByStrategyId,
          {
            params: {
              path: {
                strategyId: strategyNumber
              }
            }
          }
        );

        if (error) {
          setStatusErrorMsg(
            "Couldn't load the Comments. Please try again.",
            error
          );
        } else {
          setCommentData(
            data
              .filter((comment) => comment?.visibleOnSummary)
              .sort(
                (a, b) => Date.parse(b?.updatedOn) - Date.parse(a?.updatedOn)
              )
          );
        }
      } finally {
        decrementAPIInProgress();
      }
    }
    fetchComments();
  }, [tokenAvailable, strategyNumber]);

  return (
    <EntityListComp
      entityData={commentData}
      entityName={`${COMMENTS_TITLE}s`}
      userInfoMap={userInfoMap}
      activeSection={COMMENTS_TITLE}
      isEdit={isEdit}
      commonProps={commonProps}
    />
  );
}
